import none from '../../img/leoLogo.png'
import peanut from '../../img/shake/peanuteandjamshake.jpg'
import milkshake from '../../img/shake/milkshake.jpg'
import mangodream from '../../img/shake/mangodream.jpg'
import cheeseshake from '../../img/shake/cheeseshake.jpg'
export const shake=[
    {
      "id": "161",
      "title": "شیک چاکلت",
      "desciption": "",
      "price": "219",
      "image": none
    },
    {
      "id": "162",
      "title": "شیک دبل چاکلت",
      "desciption": "",
      "price": "225",
      "image": none
    },
    {
      "id": "163",
      "title": "شیک بنانا چاکلت",
      "desciption": "",
      "price": "228",
      "image": none
    },
    {
      "id": "164",
      "title": "شیک باربی",
      "desciption": "",
      "price": "195",
      "image": none
    },
    {
      "id": "165",
      "title": "شیک وانیل",
      "desciption": "",
      "price": "207",
      "image": none
    },
    {
      "id": "166",
      "title": "شیک قهوه",
      "desciption": "",
      "price": "228",
      "image": none
    },
    {
      "id": "167",
      "title": "شیک نوتلا",
      "desciption": "",
      "price": "225",
      "image": none
    },
    {
      "id": "168",
      "title": "شیک براونی",
      "desciption": "",
      "price": "221",
      "image": none
    },
    // {
    //   "id": "169",
    //   "title": "شیک کلاسیک",
    //   "desciption": "",
    //   "price": "140",
    //   "image": none
    // },
    {
      "id": "1610",
      "title": "شیک چیز کیک",
      "desciption": "",
      "price": "228",
      "image": none
    },
    // {
    //   "id": "1611",
    //   "title": "مام شیک",
    //   "desciption": "",
    //   "price": "130",
    //   "image": none
    // },
    {
      "id": "1612",
      "title": "شیک موکا",
      "desciption": "",
      "price": "225",
      "image": none
    },
    // {
    //   "id": "1613",
    //   "title": "شیک انرژی",
    //   "desciption": "",
    //   "price": "170",
    //   "image": none
    // },
    {
      "id": "1614",
      "title": "شیک کره بادام زمینی",
      "desciption": "",
      "price": "229",
      "image": none
    },
    {
      "id": "1615",
      "title": "شیک لوتوس",
      "desciption": "",
      "price": "192",
      "image": none
    },
    // {
    //   "id": "1616",
    //   "title": "منگو لاو",
    //   "desciption": "",
    //   "price": "145",
    //   "image": none
    // },
    {
      "id": "1617",
      "title": "شیک مارشمالا",
      "desciption": "",
      "price": "224",
      "image": none
    },
    // {
    //   "id": "1618",
    //   "title": "شیک کارامل",
    //   "desciption": "",
    //   "price": "130",
    //   "image": none
    // },
    {
      "id": "1619",
      "title": "شیک معجون",
      "desciption": "",
      "price": "228",
      "image": none
    },
    // {
    //   "id": "1620",
    //   "title": "کافی گلاسه",
    //   "desciption": "",
    //   "price": "130",
    //   "image": none
    // },
    {
      "id": "1621",
      "title": "Peanut and Jam",
      "desciption": "کره بادام زمینی+ بستنی وانیل+ مربا آبالو+ شیر",
      "price": "240",
      "image": peanut
    },
    {
      "id": "1622",
      "title": "Milk Shake",
      "desciption": "بستنی وانیل+ شیر+ پاپکورن+ کارامل",
      "price": "228",
      "image": milkshake
    },
    {
      "id": "1623",
      "title": "Mango Dream",
      "desciption": "بستنی وانیل+اب انبه+پودر دارچین+ موز+ زردچوبه",
      "price": "240",
      "image": mangodream
    },
    {
      "id": "1624",
      "title": "Cheese Shake",
      "desciption": " بستني وانيل+ليمو +پنير ماسكارپونه+شير",
      "price": "230",
      "image": cheeseshake
    },
    {
      "id": "1625",
      "title": " nut butter",
      "desciption": " کره گردو با تکه های موز",
      "price": "228",
      "image": cheeseshake
    },
    {
      "id": "1626",
      "title": "  شیک جزیره",
      "desciption": "",
      "price": "240",
      "image": cheeseshake
    },
  ]